/* critical.js defines this; when it fails to load, update the URL directly instead of throwing. */
if (!window.updateHistoryAfterPaint) {
    window.updateHistoryAfterPaint = (url, state = {}, method = 'replaceState') => {
        window.history[method](state, '', url);
    };
}

(function() {
    /* Tabs */
    {
        function initTabs(el) {
            const name = el.dataset.tabs;

            const tabsSwitchEls = document.querySelectorAll(`input[name$="${name}"]`);
            const tabsContentEls = document.querySelectorAll(`[data-tabs="${name}"] [data-tab]`);

            tabsSwitchEls.forEach(function(radio) {
                const selectedValue = radio.value;
                const selectedTabEls = document.querySelectorAll(`[data-tabs="${name}"] [data-tab="${selectedValue}"]`);

                radio.addEventListener('change', function() {
                    if (radio.checked) {
                        tabsContentEls.forEach(function(tabContentEl) {
                            tabContentEl.classList.add('hidden');
                        });
                        selectedTabEls.forEach(function (tabEl) {
                            tabEl.classList.remove('hidden');
                            if (tabEl.hasAttribute('data-hover-triggers')) {
                                tabEl.firstElementChild.dispatchEvent(new Event('mouseover'));
                            }
                        });
                        const scrollContainer = el.querySelector('.get-here-block__tabs-scroll');
                        if (scrollContainer) {
                            const label = radio.closest('.tab')?.querySelector('label');
                            if (label) {
                                label.scrollIntoView({ behavior: 'smooth', inline: 'end', block: 'nearest' });
                            }
                        }
                    }
                });
            });
        }

        const tabs = document.querySelectorAll(`[data-tabs]`);
        tabs.forEach(function(el) {
            initTabs(el);
        });
    }

    /* Hover tabs */
    {
        function initHoverTabs(name) {
            const tabsHoverTriggerEls = document.querySelectorAll(`[data-hover-trigger]`);
            const tabsHoverContentEls = document.querySelectorAll(`[data-hover-tabs="${name}"] [data-hover-tab]`);

            tabsHoverTriggerEls.forEach(function(trigger) {
                const selectedValue = trigger.dataset.hoverTrigger;
                const selectedHoverTabEls = document.querySelectorAll(`[data-hover-tabs="${name}"] [data-hover-tab="${selectedValue}"]`);

                trigger.addEventListener('mouseover', function() {
                    tabsHoverTriggerEls.forEach(function(el) {
                        el.classList.remove('active');
                    });

                    trigger.classList.add('active');

                    tabsHoverContentEls.forEach(function(el) {
                        const imgEl = el.querySelector('img');
                        const imgSrc = imgEl.src;
                        const imgSrcObj = new URL(imgSrc);
                        imgSrcObj.search = '';
                        const cleanImgSrc = imgSrcObj.toString().replace('https://vcgallery.it/files/vcgallery-public/', '');
                        const gcsSwapBadgeEl = document.querySelector(`.gcs-swap-badge[data-object="${cleanImgSrc}"]`);
                        if (gcsSwapBadgeEl) {
                            gcsSwapBadgeEl.style.display = 'none';
                        }

                        el.classList.add('hidden');
                    });
                    selectedHoverTabEls.forEach(function (el) {
                        const imgEl = el.querySelector('img');
                        const imgSrc = imgEl.src;
                        const imgSrcObj = new URL(imgSrc);
                        imgSrcObj.search = '';
                        const cleanImgSrc = imgSrcObj.toString().replace('https://vcgallery.it/files/vcgallery-public/', '');
                        const gcsSwapBadgeEl = document.querySelector(`.gcs-swap-badge[data-object="${cleanImgSrc}"]`);
                        if (gcsSwapBadgeEl) {
                            gcsSwapBadgeEl.style.display = 'flex';
                            window.dispatchEvent(new CustomEvent('scroll'));
                        }

                        el.classList.remove('hidden');
                    });
                });
            });
        }

        const hoverTabs = document.querySelectorAll(`[data-hover-tabs]`);
        hoverTabs.forEach(function(el) {
            const name = el.dataset.hoverTabs;
            initHoverTabs(name);
        });
    }

    /* Scroll to center  */
    {
        function scrollToCenter() {
            const els = document.querySelectorAll('.center-scroll');
            els.forEach(function (el) {
                const contentWidth = el.scrollWidth;
                const visibleWidth = el.clientWidth;
                const maxScrollRange = contentWidth - visibleWidth;
                el.scrollLeft = maxScrollRange / 2;
            });
        }

        window.addEventListener('load', function () {
            scrollToCenter();
        });
    }

    /* Set display size */
    {
        function setDisplaySize() {
            const isMobile = window.matchMedia('(max-width: 768px)').matches;
            if (isMobile) {
                document.body.classList.add('display-small');
            } else {
                document.body.classList.remove('display-small');
            }
        }

        function setDetailsOnSmallDisplayState() {
            const detailsElements = document.querySelectorAll('.details-m');
            const isMobile = document.body.classList.contains('display-small');

            detailsElements.forEach(function(details) {
                if (isMobile) {
                    details.removeAttribute('open');
                } else {
                    details.setAttribute('open', '');
                }
            });
        }

        window.addEventListener('load', function () {
            setDisplaySize();
            setDetailsOnSmallDisplayState();
        });

        window.addEventListener('resize', function() {
            setDisplaySize();
            setDetailsOnSmallDisplayState();
        });
    }

    /* Drag scroll */
    {
        // document.addEventListener('DOMContentLoaded', () => {
        //     const dragToSlideEls = document.querySelectorAll('.drag-scroll');
        //     const hasTouchScreen = ('ontouchstart' in window);
        //
        //     dragToSlideEls.forEach(function (slider) {
        //         let positionLeft = 0;
        //         let positionX = 0;
        //
        //         function mouseMoveHandler(e) {
        //             const dx = e.clientX - positionX;
        //
        //             slider.scrollLeft = positionLeft - dx;
        //         }
        //
        //         function mouseUpHandler(e) {
        //             document.removeEventListener('mousemove', mouseMoveHandler);
        //             document.removeEventListener('mouseup', mouseUpHandler);
        //             slider.classList.remove('drag-scroll--scrolling');
        //         }
        //
        //         function mouseDownHandler(e) {
        //             slider.classList.add('drag-scroll--scrolling');
        //
        //             positionLeft = slider.scrollLeft;
        //             positionX = e.clientX;
        //
        //             document.addEventListener('mousemove', mouseMoveHandler);
        //             document.addEventListener('mouseup', mouseUpHandler);
        //         }
        //
        //         function mouseClickHandler(e) {
        //             if (positionX !== e.clientX) {
        //                 e.preventDefault();
        //             }
        //         }
        //
        //         function dragScrollWatcher() {
        //             if (!hasTouchScreen) {
        //                 slider.addEventListener('mousedown', mouseDownHandler);
        //                 slider.addEventListener('click', mouseClickHandler);
        //             } else {
        //                 slider.removeEventListener('mousedown', mouseDownHandler);
        //             }
        //         }
        //
        //         dragScrollWatcher();
        //         window.addEventListener('resize', dragScrollWatcher);
        //     });
        // });
    }

    document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('[data-slider-dots]').forEach(function(el) {
           const slider = el.querySelector('[data-slider-dots-slider]');
           const dots = el.querySelectorAll('[data-slider-dots-dot]');
           const slides = el.querySelectorAll('[data-slider-dots-slide]');

            const observerOptions = {
                root: slider,
                rootMargin: '-24px',
                threshold: 0.6,
            };

            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        dots.forEach((dot) => {
                            dot.classList.remove('active');
                        });

                        dots.forEach((dot) => {
                            if (dot.dataset.sliderDotsDot === entry.target.dataset.sliderDotsSlide) {
                                dot.classList.add('active');
                            }
                        });
                    }
                });
            }, observerOptions);

            slides.forEach((slide) => {
                observer.observe(slide);
            });

            dots.forEach((el) => {
                el.addEventListener('click', () => {
                    const slide = slider.querySelector(`[data-slider-dots-slide="${el.dataset.sliderDotsDot}"]`);
                    slider.scrollTo({top: 0, left: slide.offsetLeft, behavior: 'smooth'});
                });
            });
        });

        document.querySelectorAll('[data-show-sticky]').forEach(function(el) {
            const spyEl = document.querySelector(el.dataset.showSticky);

            if (spyEl) {
                const observerOptions = {
                    root: document,
                    rootMargin: '-1px',
                    threshold: 0.6,
                };

                const observer = new IntersectionObserver((entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            el.classList.add('hidden');
                        } else {
                            el.classList.remove('hidden');
                        }
                    });

                    // Lets floating widgets (chat, back to top) move above the sticky bar
                    const stickyHeight = el.offsetHeight;
                    document.documentElement.classList.toggle('sticky-cta-visible', stickyHeight > 0);
                    document.documentElement.style.setProperty('--sticky-cta-height', `${stickyHeight}px`);
                }, observerOptions);

                observer.observe(spyEl);
            } else {
                el.classList.remove('hidden');
            }
        });
    });
})();

function fixTouches(e) {
    if(e.touches) {
        e.clientX = e.touches[0].clientX;
        e.clientY = e.touches[0].clientY;
    }
}

(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['exports'], factory);
    } else if (typeof exports !== 'undefined') {
        factory(exports);
    } else {
        factory((root.dragscroll = {}));
    }
}(this, function (exports) {
    var _window = window;
    var _document = document;
    var mousemove = 'mousemove touchmove';
    var mouseup = 'mouseup touchend';
    var mousedown = 'mousedown touchstart';
    var EventListener = 'EventListener';
    var addEventListener = 'add'+EventListener;
    var removeEventListener = 'remove'+EventListener;
    var newScrollX, newScrollY;

    var dragged = [];
    var reset = function(i, el) {
        for (i = 0; i < dragged.length;) {
            el = dragged[i++];
            el = el.container || el;
            el[removeEventListener](mousedown, el.md, 0);
            mouseup.split(' ').forEach(function(ev) {
                _window[removeEventListener](ev, el.mu, 0);
            });
            mousemove.split(' ').forEach(function(ev) {
                _window[removeEventListener](ev, el.mm, 0);
            });
        }

        // cloning into array since HTMLCollection is updated dynamically
        dragged = [].slice.call(_document.getElementsByClassName('drag-scroll'));
        for (i = 0; i < dragged.length;) {
            (function(el, lastClientX, lastClientY, pushed, scroller, cont){

                mousedown.split(' ').forEach(function(ev) {
                    (cont = el.container || el)[addEventListener](
                        ev,
                        cont.md = function(e) {
                            fixTouches(e);
                            if (!el.hasAttribute('nochilddrag') ||
                                _document.elementFromPoint(
                                    e.pageX,
                                    e.pageY
                                ) == cont
                            ) {
                                pushed = 1;
                                lastClientX = e.clientX;
                                // lastClientY = e.clientY;

                                // e.preventDefault();
                            }
                        }, 0
                    );
                });

                mouseup.split(' ').forEach(function(ev) {
                    _window[addEventListener](
                        ev, cont.mu = function() {
                            pushed = 0;
                            el.classList.remove('drag-scroll--scrolling');
                        }, 0
                    );
                });
                mousemove.split(' ').forEach(function(ev) {
                    _window[addEventListener](
                        ev,
                        cont.mm = function(e) {
                            fixTouches(e);
                            if (pushed) {
                                el.classList.add('drag-scroll--scrolling');
                                (scroller = el.scroller||el).scrollLeft -=
                                    newScrollX = (- lastClientX + (lastClientX=e.clientX));
                                // scroller.scrollTop -=
                                //     newScrollY = (- lastClientY + (lastClientY=e.clientY));
                                if (el == _document.body) {
                                    (scroller = _document.documentElement).scrollLeft -= newScrollX;
                                    // scroller.scrollTop -= newScrollY;
                                }
                            }
                        }, 0
                    );
                });
            })(dragged[i++]);
        }
    }


    if (_document.readyState == 'complete') {
        reset();
    } else {
        _window[addEventListener]('load', reset, 0);
    }

    exports.reset = reset;
}));

class HTMLUpdateUtility {
    /**
     * Used to swap an HTML node with a new node.
     * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
     *
     * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
     */
    static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
        preProcessCallbacks?.forEach((callback) => callback(newContent));

        const newNodeWrapper = document.createElement('div');
        HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
        const newNode = newNodeWrapper.firstChild;

        // dedupe IDs
        const uniqueKey = Date.now();
        oldNode.querySelectorAll('[id], [form]').forEach((element) => {
            element.id && (element.id = `${element.id}-${uniqueKey}`);
            element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
        });

        oldNode.parentNode.insertBefore(newNode, oldNode);
        oldNode.style.display = 'none';

        postProcessCallbacks?.forEach((callback) => callback(newNode));

        setTimeout(() => oldNode.remove(), 500);
    }

    // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
    static setInnerHTML(element, html) {
        element.innerHTML = html;
        element.querySelectorAll('script').forEach((oldScriptTag) => {
            const newScriptTag = document.createElement('script');
            Array.from(oldScriptTag.attributes).forEach((attribute) => {
                newScriptTag.setAttribute(attribute.name, attribute.value);
            });
            newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
            oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
    }
}

if (!customElements.get('quantity-input')) {
    class QuantityInput extends HTMLElement {
        quantityUpdateUnsubscriber = undefined;
        cartErrorUnsubscriber = undefined;

        constructor() {
            super();

            this.changeEvent = new Event('change', { bubbles: true });
        }

        // Children are read here, not in the constructor: createElement or a clone constructs the
        // element before its <input> exists, which used to throw on this.input.addEventListener.
        initInput() {
            if (this.input) {
                return true;
            }

            const input = this.querySelector('input');
            if (!input) {
                return false;
            }

            this.input = input;
            this.input.addEventListener('input', this.onInputChange.bind(this));
            this.input.addEventListener('change', this.onInputChange.bind(this));
            this.querySelectorAll('button').forEach((button) =>
                button.addEventListener('click', this.onButtonClick.bind(this))
            );

            return true;
        }

        getMin() {
            return Number.parseInt(this.input.min, 10) || 1;
        }

        getMax() {
            if (!this.input.max) {
                return null;
            }

            const max = Number.parseInt(this.input.max, 10);
            return Number.isNaN(max) ? null : max;
        }

        getStep() {
            return Number.parseInt(this.input.step, 10) || 1;
        }

        getParsedValue(rawValue = this.input.value) {
            const value = Number.parseInt(rawValue, 10);
            return Number.isNaN(value) ? null : value;
        }

        isValueValid(rawValue = this.input.value) {
            const value = this.getParsedValue(rawValue);
            if (value === null) {
                return false;
            }

            if (value < this.getMin()) {
                return false;
            }

            const max = this.getMax();
            if (max !== null && value > max) {
                return false;
            }

            return (value - this.getMin()) % this.getStep() === 0;
        }

        sanitizeValue(rawValue = this.input.value) {
            const min = this.getMin();
            const max = this.getMax();
            const step = this.getStep();
            let value = this.getParsedValue(rawValue);

            if (value === null || value < min) {
                value = min;
            }

            if (max !== null && value > max) {
                value = max;
            }

            const stepOffset = (value - min) % step;
            if (stepOffset !== 0) {
                value -= stepOffset;
                if (value < min) {
                    value = min;
                }
            }

            this.input.value = value;
            return value;
        }

        syncSubmitButtonState() {
            const container = this.closest('product-info') || this.closest('.sidebar__wrapper');
            const productForm = container?.querySelector('product-form');
            const submitButton = productForm?.querySelector('[type="submit"]');
            if (!productForm || !submitButton) {
                return;
            }

            const isValid = this.isValueValid();
            productForm.dataset.quantityInvalid = String(!isValid);

            if (!isValid) {
                submitButton.setAttribute('disabled', 'disabled');
                submitButton.setAttribute('aria-disabled', 'true');
                return;
            }

            submitButton.removeAttribute('aria-disabled');
            if (productForm.dataset.variantAvailable !== 'false') {
                submitButton.removeAttribute('disabled');
            }
        }

        connectedCallback() {
            if (!this.initInput()) {
                if (document.readyState === 'loading') {
                    document.addEventListener('DOMContentLoaded', () => this.isConnected && this.connectedCallback(), { once: true });
                }
                return;
            }

            if (this.quantityUpdateUnsubscriber) {
                return;
            }

            this.validateQtyRules();
            this.quantityUpdateUnsubscriber = window.subscribe(window.PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
            this.cartErrorUnsubscriber = window.subscribe(window.PUB_SUB_EVENTS.cartError, this.onCartError.bind(this));
        }

        disconnectedCallback() {
            if (this.quantityUpdateUnsubscriber) {
                this.quantityUpdateUnsubscriber();
                this.quantityUpdateUnsubscriber = undefined;
            }
            if (this.cartErrorUnsubscriber) {
                this.cartErrorUnsubscriber();
                this.cartErrorUnsubscriber = undefined;
            }
        }

        onCartError({ noMore }) {
            this.querySelector('[name="plus"]').disabled = noMore;
        }

        onInputChange(event) {
            this.validateQtyRules();
        }

        onButtonClick(event) {
            event.preventDefault();
            const button = event.currentTarget;
            const previousValue = this.input.value;

            if (button.name === 'plus') {
                if (this.getMin() > this.getStep() && Number.parseInt(this.input.value, 10) === 0) {
                    this.input.value = this.getMin();
                } else {
                    this.input.stepUp();
                }
            } else {
                this.input.stepDown();
            }

            this.sanitizeValue();

            if (previousValue !== this.input.value) {
                this.input.dispatchEvent(this.changeEvent);
            }

            if (Number.parseInt(previousValue, 10) <= this.getMin() && button.name === 'minus') {
                this.input.value = this.getMin();
            }
        }

        validateQtyRules() {
            const value = this.getParsedValue();
            if (this.input.min) {
                const buttonMinus = this.querySelector("button[name='minus']");
                buttonMinus.classList.toggle('disabled', value !== null && value <= this.getMin());
            }
            const buttonPlus = this.querySelector("button[name='plus']");
            const max = this.getMax();
            if (max !== null) {
                buttonPlus.classList.toggle('disabled', value !== null && value >= max);
            } else {
                buttonPlus.classList.remove('disabled');
            }

            this.syncSubmitButtonState();
        }
    }
    customElements.define('quantity-input', QuantityInput);
}

if (!customElements.get('product-form')) {
    class ProductForm extends HTMLElement {
        onVariantChangeUnsubscriber = undefined;

        // Children are read here, not in the constructor: createElement or a clone constructs the
        // element before its <form> exists, which used to throw in the variantIdInput getter.
        initForm() {
            if (this.form) {
                return true;
            }

            const form = this.querySelector('form');
            const submitButton = this.querySelector('[type="submit"]');
            if (!form || !submitButton) {
                return false;
            }

            this.form = form;
            if (this.variantIdInput) {
                this.variantIdInput.disabled = false;
            }

            this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
            // this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            this.cart = document.querySelector('cart-drawer');
            this.submitButton = submitButton;
            this.dataset.variantAvailable = String(!this.submitButton.disabled);
            // this.submitButtonText = this.submitButton.querySelector('span');

            // if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
            // this.hideErrors = this.dataset.hideErrors === 'true';

            return true;
        }

        connectedCallback() {
            if (!this.initForm()) {
                if (document.readyState === 'loading') {
                    document.addEventListener('DOMContentLoaded', () => this.isConnected && this.connectedCallback(), { once: true });
                }
                return;
            }

            if (this.onVariantChangeUnsubscriber) {
                return;
            }

            this.onVariantChangeUnsubscriber = window.subscribe(
                window.PUB_SUB_EVENTS.variantChange,
                this.handleVariantChange.bind(this)
            );
        }

        disconnectedCallback() {
            if (this.onVariantChangeUnsubscriber) {
                this.onVariantChangeUnsubscriber();
                this.onVariantChangeUnsubscriber = undefined;
            }
        }

        handleVariantChange({ variant, productId }) {
            if (this.dataset.productId && productId && this.dataset.productId != productId) {
                return;
            }

            this.querySelector('[name="id"]').value = variant.id;
            this.dataset.variantId = variant.id;
            this.dataset.variantAvailable = String(variant.available);
            this.clearErrorMessage();
            this.submitButton.disabled = !variant.available;
            if (variant.available) {
                this.submitButton.removeAttribute('aria-disabled');
            }
            const priceEl = this.querySelector('[data-price]');
            if (priceEl) {
                priceEl.dataset.price = variant.price;
                priceEl.innerHTML = formatMoney(variant.price);
            }
            this.dataset.productTitle = variant.name;
            this.syncSubmitButtonState();
        }

        getSectionsToRender() {
            /* TODO: Review */
            return [
                {
                    id: 'open-cart-drawer',
                    section: 'cart-bubble',
                    selector: '[data-open-card-drawer] .header__nav__action__indicator'
                },
                {
                    id: 'open-cart-drawer--mobile',
                    section: 'cart-bubble',
                    selector: '[data-open-card-drawer] .header__nav__action__indicator'
                }
            ];
        }

        getQuantityInput() {
            const container = this.closest('product-info') || this.closest('.sidebar__wrapper');
            return container?.querySelector('quantity-input');
        }

        syncSubmitButtonState() {
            const quantityInput = this.getQuantityInput();
            if (quantityInput && typeof quantityInput.validateQtyRules === 'function') {
                quantityInput.validateQtyRules();
                return;
            }

            if (this.dataset.variantAvailable === 'false') {
                this.submitButton.setAttribute('disabled', 'disabled');
            } else {
                this.submitButton.removeAttribute('disabled');
            }
        }

        isSoldOutErrorMessage(message = '') {
            return message.endsWith('is already sold out.') || message.endsWith('è già esaurito.');
        }

        refreshCartState(productVariantId) {
            return fetch(`${Shopify.routes.root}?sections=cart-bubble`)
                .then((response) => response.json())
                .then((sections) => {
                    return publish(window.PUB_SUB_EVENTS.cartUpdate, {
                        source: 'product-form',
                        productVariantId,
                        cartData: { sections },
                    });
                });
        }

        onSubmitHandler(evt) {
            evt.preventDefault();
            if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

            this.clearErrorMessage();

            const quantityInput = this.getQuantityInput();
            if (quantityInput && typeof quantityInput.isValueValid === 'function' && !quantityInput.isValueValid()) {
                quantityInput.validateQtyRules();
                return;
            }

            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.classList.add('loading');
            this.querySelector('.loading__spinner').classList.remove('hidden');

            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];

            const formData = new FormData(this.form);
            if (this.cart && evt.target.closest('cart-drawer')) {
                formData.append(
                    'sections',
                    this.cart.getSectionsToRender().map((section) => section.section)
                );
                formData.append('sections_url', window.location.pathname);
                // this.cart.setActiveElement(document.activeElement);
            } else {
                formData.append(
                    'sections',
                    this.getSectionsToRender().map((section) => section.section)
                );
                formData.append('sections_url', window.location.pathname);
            }
            config.body = formData;

            fetch(`${Shopify.routes.root}cart/add.js`, config)
                .then((response) => response.json())
                .then((response) => {
                    const variantId = formData.get('id');

                    if (response.status) {
                        this.handleErrorMessage(variantId, response.description);
                        const isSoldOut = this.isSoldOutErrorMessage(response.description);
                        this.dataset.variantAvailable = String(!isSoldOut);

                        if (isSoldOut) {
                            this.submitButton.setAttribute('disabled', 'disabled');
                        } else {
                            this.submitButton.removeAttribute('disabled');
                        }

                        return this.refreshCartState(variantId);
                    }

                    const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
                    return publish(window.PUB_SUB_EVENTS.cartUpdate, {
                        source: 'product-form',
                        productVariantId: formData.get('id'),
                        cartData: response,
                    }).then(() => {
                        CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
                    });
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally(() => {
                    this.submitButton.classList.remove('loading');
                    if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                    this.submitButton.removeAttribute('aria-disabled');
                    this.syncSubmitButtonState();
                    this.querySelector('.loading__spinner').classList.add('hidden');

                    CartPerformance.measureFromEvent("add:user-action", evt);
                });
        }

        clearErrorMessage() {
            const errorMessageEl = document.querySelector('.product__right-cta-message');
            if (!errorMessageEl) {
                return;
            }

            errorMessageEl.classList.add('hidden');
            errorMessageEl.innerHTML = '';
        }

        handleErrorMessage(variantId, errorMessage = '') {
            const errorMessageEl = document.querySelector('.product__right-cta-message');
            if (!errorMessageEl) {
                return;
            }

            errorMessageEl.classList.toggle('hidden', !errorMessage);
            errorMessageEl.innerHTML = errorMessage;

            if (errorMessage) {
                const errorEventBody = {
                        source: 'product-form',
                        productVariantId: variantId,
                        noMore: false,
                    }

                if (errorMessage.endsWith('is already sold out.') || errorMessage.endsWith('è già esaurito.')) {
                    errorMessage = window.translate.cart.sold_out_error_html.replace('[message]', errorMessage);
                } else {
                    errorEventBody['noMore'] = true;
                }

                publish(window.PUB_SUB_EVENTS.cartError, errorEventBody);

                errorMessageEl.innerHTML = errorMessage;
            }
        }

        // toggleSubmitButton(disable = true, text) {
        //     if (disable) {
        //         this.submitButton.setAttribute('disabled', 'disabled');
        //         if (text) this.submitButtonText.textContent = text;
        //     } else {
        //         this.submitButton.removeAttribute('disabled');
        //         this.submitButtonText.textContent = window.variantStrings.addToCart;
        //     }
        // }

        get variantIdInput() {
            return this.form?.querySelector('[name=id]') ?? null;
        }
    }
    customElements.define('product-form', ProductForm);
}

if (!customElements.get('variant-selects')) {
    class VariantSelects extends HTMLElement {
        constructor() {
            super();
            this.reinitSwatches();
            this.shouldUpdateURL = Boolean(this.dataset.updateUrl);
            // this.productWrapper = this.closest('.thb-product-detail');
            // this.productSlider = this.productWrapper.querySelector('.product-images');
            // this.hideVariants = this.dataset.hideVariants === 'true';
        }

        connectedCallback() {
            const activeSwatch = this.querySelector('.variant-swatch.active');

            if (activeSwatch) {
                this.currentVariantId = activeSwatch.dataset.variantId;
            }

            if (this.currentVariantId) {
                // this.updateOptions();
                this.updateCurrentVariant();
                // this.setDisabled();
                // this.setImageSet();
            }
        }

        initSwatchesListeners() {
            if (this.swatches.length > 1) {
                this.swatches.forEach(el => el.addEventListener('click', e => this.setActiveSwatchOnClick(e)))
            }
        }

        reinitSwatches() {
            this.swatches = this.querySelectorAll('.variant-swatch') || [];
            this.initSwatchesListeners();
        }

        // updateOptions() {
        // this.options = [];
        // this.similarOptions = this.dataset.similarOptions;
        //
        // this.fieldsets.forEach((fieldset, i) => {
        //     if (fieldset.querySelector('select')) {
        //         this.options.push(fieldset.querySelector('select').value);
        //     } else if (fieldset.querySelectorAll('input').length) {
        //         this.options.push(fieldset.querySelector('input:checked').value);
        //     }
        // });
        // }

        updateCurrentVariant(currentVariantId) {
            if (currentVariantId) {
                this.currentVariantId = currentVariantId;
            }

            const variantData = this.getVariantData();

            if (variantData) {
                this.currentVariant = variantData.find(variant => variant.id == this.currentVariantId);
            }
        }

        onVariantChange(event) {
            // this.updateOptions();
            this.updateCurrentVariant();
            // this.updatePickupAvailability();
            // this.removeErrorMessage();
            // this.updateVariantText();
            // this.setDisabled();
            // if (!this.currentVariant) {
            //     this.toggleAddButton(true, '', true);
            //     this.setUnavailable();
            //     this.fallbackVariant(event);
            // } else {
            //     if (!this.currentVariant.available) {
            //         this.toggleAddButton(true, window.theme.variantStrings.soldOut, true);
            //     } else {
            //         this.toggleAddButton(false, '', true, this.currentVariant.price);
            //     }
            //     this.setActiveSwatch();
            //     this.updateMedia();
                if (this.shouldUpdateURL) {
                    this.updateURL();
                }
            //     this.updateVariantInput();
            //     this.renderProductInfo();
            // }
            // dispatchCustomEvent(window.PUB_SUB_EVENTS.variantChange, {
            //     variant: this.currentVariant,
            //     sectionId: this.dataset.section
            // });

            if (this.closest('product-info')) {
                this.renderProductInfo();
            }

            this.querySelector('.variant__option__value').textContent = this.currentVariant.title;

            // const quantityShips = this.querySelector('.product__inventory__status');
            // quantityShips.innerText = firstVariant.quantity_ships;
            // quantityShips.className = `product__inventory__status product__inventory__status--${firstVariant.inventory_status}`;

            window.publish(window.PUB_SUB_EVENTS.variantChange, {
                variant: this.currentVariant,
                productId: this.dataset.productId,
                sectionId: this.dataset.section
            });
        }

        updateURL() {
            if (!this.currentVariant || this.shouldUpdateURL === false) return;
            window.updateHistoryAfterPaint(`${this.dataset.url}?variant=${this.currentVariant.id}`);
        }

        getSectionsToRender() {
            // return [`price-${this.dataset.section}`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `add-to-cart-${this.dataset.section}`];
            return ['product__right-price-row', '.product__variant__sku', '.product__inventory__status'];
        }

        renderProductInfo() {
            const productInfo = this.closest('product-info');
            if (!productInfo) {
                return;
            }

            let sections = this.getSectionsToRender();
            let productUrl = `${this.dataset.url}?variant=${this.currentVariant.id}`;
            if (this.dataset.section && !this.dataset.section.startsWith('home__hero') && !this.dataset.section.startsWith('home__collections')) {
                // productUrl += `&section_id=${this.dataset.section}`;
                productUrl += `&section_id=main-product`;
            }

            // Variant requests can resolve out of order on fast switching: only the latest one is applied
            const requestedVariantId = this.currentVariant.id;

            fetch(productUrl)
                .then((response) => response.text())
                .then((responseText) => {
                    if (this.currentVariant?.id !== requestedVariantId) return;

                    const html = new DOMParser().parseFromString(responseText, 'text/html');
                    sections.forEach((selector) => {
                        const destination = productInfo.querySelector(selector);
                        const source = html.querySelector(selector);

                        if (source && destination) {
                            if (selector === '.product__inventory__status') {
                                destination.className = source.className;
                            }
                            destination.innerHTML = source.innerHTML;
                        }

                        // const price = document.getElementById(selector);
                        // if (price) price.classList.remove('visibility-hidden');
                    });

                    // Quantity rules (min, step) and the stock limit (max) are per variant,
                    // so take them from the freshly rendered input
                    const quantityInput = productInfo.querySelector('quantity-input');
                    const sourceQuantityField = html.querySelector('quantity-input input[name="quantity"]');
                    if (quantityInput && sourceQuantityField) {
                        ['min', 'max', 'step'].forEach((attribute) => {
                            if (sourceQuantityField.hasAttribute(attribute)) {
                                quantityInput.input.setAttribute(attribute, sourceQuantityField.getAttribute(attribute));
                            } else {
                                quantityInput.input.removeAttribute(attribute);
                            }
                        });
                        quantityInput.sanitizeValue();
                        quantityInput.validateQtyRules();
                        quantityInput.input.dispatchEvent(new Event('change', { bubbles: true }));
                    }

                    // Update the add-to-cart section when variant availability changes
/*                    const addToCartContainer = document.querySelector('.product-add-to-cart-container');
                    if (addToCartContainer) {
                        const sourceContainer = html.querySelector('.product-add-to-cart-container');
                        if (sourceContainer && !this.currentVariant.available) {
                            addToCartContainer.innerHTML = sourceContainer.innerHTML;
                        }
                    }*/

                    if (!this.currentVariant.available) {
                        this.toggleAddButton(true, window.translate.product.buy_button.sold_out);
                    } else {
                        this.toggleAddButton(false, window.translate.product.buy_button.add_to_cart, this.currentVariant.price);
                    }
                });
        }

        toggleAddButton(disable = true, text = '', price) {
            const productInfo = this.closest('product-info') || this.closest('#ProductDrawer .sidebar__wrapper');
            if (!productInfo) return;

            const productForm = productInfo.querySelector('product-form');
            if (!productForm) return;

            const buyButton = productForm.querySelector('.buy-button');
            if (!buyButton) return;

            const buyButtonText = buyButton.querySelector('[data-text]');
            const addButtonPrice = buyButton.querySelector('[data-price]');

            if (disable) {
                buyButton.setAttribute('disabled', 'disabled');
                buyButtonText.textContent = translate.product.buy_button.sold_out;
            } else {
                buyButton.removeAttribute('disabled');
                buyButtonText.textContent = window.translate.product.buy_button.add_to_cart;
            }

            if (price) {
                if (addButtonPrice) {
                    const quantityField = productInfo.querySelector('quantity-input input[name="quantity"]');
                    const quantity = this.getValidQuantityValue(quantityField);
                    addButtonPrice.dataset.price = price;
                    addButtonPrice.innerHTML = formatMoney(price * quantity);
                }
            }
        }

        getValidQuantityValue(quantityField) {
            if (!quantityField) {
                return 1;
            }

            const quantity = Number.parseInt(quantityField.value, 10);
            const min = Number.parseInt(quantityField.min, 10) || 1;
            const max = quantityField.max ? Number.parseInt(quantityField.max, 10) : null;
            const step = Number.parseInt(quantityField.step, 10) || 1;

            if (
                Number.isNaN(quantity) ||
                quantity < min ||
                (max !== null && quantity > max) ||
                (quantity - min) % step !== 0
            ) {
                return 1;
            }

            return quantity;
        }

        markSwatchAsActive(selectedVariantId) {
            if (selectedVariantId) {
                this.swatches.forEach(el => {
                    if (el.dataset.variantId === selectedVariantId) {
                        el.classList.add('active');
                        this.currentVariantId = selectedVariantId;
                    } else {
                        el.classList.remove('active');
                    }
                });
            } else {
                const moreVariantSwatch = this.querySelector('.more-variant-swatch');
                this.swatches.forEach(el => {
                    el.classList.remove('active');
                });
                moreVariantSwatch.classList.add('active');
            }
        }

        setActiveSwatchOnClick(event) {
            const selectedSwatch = event.target.closest('.variant-swatch');
            let selectedVariant = selectedSwatch.dataset.variantId;

            const moreVariantSwatch = this.querySelector('.more-variant-swatch');
            if (moreVariantSwatch) {
                moreVariantSwatch.classList.remove('active');
            }

            this.markSwatchAsActive(selectedVariant);

            this.swatches.forEach(el => {
                if (el.dataset.variantId === selectedVariant) {
                    el.classList.add('active');
                    this.currentVariantId = selectedVariant;
                } else {
                    el.classList.remove('active');
                }
            });

            this.onVariantChange(event);
            // this.updateVariantViaSwatch(event, selectedSwatch);
            // this.setActiveSwatchTitle(selectedSwatch.dataset.variantTitle);

            if (selectedSwatch.dataset.mediaId) {
                const mediaContainer = this.closest('product-info') || this.closest('#ProductDrawer') || document;
                const media = mediaContainer.querySelector(`.product__slider__slide[data-media-id='${selectedSwatch.dataset.mediaId}']`);
                media?.scrollIntoView({ behavior: 'instant', block: 'center' });
            }
        }

        getVariantData() {
            this.variantData = this.variantData || JSON.parse(this.querySelector('[data-product-variants]').textContent);

            return this.variantData;
        }
    }

    customElements.define('variant-selects', VariantSelects);
}

if (!customElements.get('more-variants-drawer')) {
    class MoreVariantsDrawer extends HTMLElement {
        onVariantChangeUnsubscriber = undefined;

        constructor() {
            super();

            this.attachShadow({ mode: 'open' });
            this.shadowRoot.innerHTML = `<div class="dialog-wrapper"><slot></slot></div>`;

            this.wrapper = this.shadowRoot.querySelector('.dialog-wrapper');
        }

        // Children are read here, not in the constructor: a clone or a renderer can construct the
        // element before its <dialog> exists, which used to throw on this.drawer.addEventListener.
        initDrawer() {
            if (this.drawer) {
                return true;
            }

            const drawer = this.querySelector('dialog');
            if (!drawer) {
                return false;
            }

            this.drawer = drawer;

            this.openDrawerEls = document.querySelectorAll('[data-open-more-variants-drawer]');
            this.closeDrawerEls = this.querySelectorAll('[data-close-drawer]');

            this.openDrawerEls.forEach((el) => {
                el.addEventListener('click', () => {
                    this.open();
                });
            });

            this.closeDrawerEls.forEach((el) => {
                el.addEventListener('click', () => {
                    this.close();
                });
            });

            this.addEventListener('keyup', (e) => e.code === 'Escape' && this.close());

            this.drawer.addEventListener('click', (e) => {
                if (e.target === this.drawer) {
                    this.close();
                }
            });

            this.swatches = this.querySelectorAll('.more-variants__item') || [];

            return true;
        }

        connectedCallback() {
            if (!this.initDrawer() && document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', () => this.initDrawer(), { once: true });
            }

            this.onVariantChangeUnsubscriber = window.subscribe(
                window.PUB_SUB_EVENTS.variantChange,
                this.handleVariantChange.bind(this)
            );

            this.querySelectorAll('.more-variants__item').forEach(el => {
                el.addEventListener('click', (e) => {
                    const selectedSwatch = e.target.closest('.more-variants__item');
                    let selectedVariantId = selectedSwatch.dataset.variantId;
                    const moreVariantSwatch = document.querySelector('.more-variant-swatch');
                    const variantSelects = document.querySelector('variant-selects');

                    if (variantSelects) {
                        variantSelects.updateCurrentVariant(selectedVariantId);
                        variantSelects.onVariantChange({});
                        variantSelects.markSwatchAsActive(selectedVariantId);
                    }

                    if (moreVariantSwatch) {
                        if (el.dataset.index > 5) {
                            moreVariantSwatch.classList.add('active');
                        } else {
                            moreVariantSwatch.classList.remove('active');
                        }
                    }
                });
            });

            // Scroll product gallery to active variant image
            const activeVariant = this.querySelector('.more-variants__item.active');
            if (activeVariant?.dataset?.mediaId) {
                const media = document.querySelector(`.product__slider__slide[data-media-id='${activeVariant.dataset.mediaId}']`);
                media?.scrollIntoView({ behavior: 'instant', block: 'center' });
            }
        }

        disconnectedCallback() {
            if (this.onVariantChangeUnsubscriber) {
                this.onVariantChangeUnsubscriber();
            }
        }

        close() {
            if (!this.drawer) {
                return;
            }

            this.wrapper.style.display = 'none';
            this.drawer.close();
        }

        open() {
            if (!this.initDrawer()) {
                return;
            }

            this.wrapper.style.display = 'block';
            if (!this.drawer.open) this.drawer.showModal();
            this.drawer.focus({preventScroll: false});
        }

        handleVariantChange({ variant, productId }) {
            if (productId != this.dataset.productId) {
                return;
            }
            this.selectSwatch(variant.id);
        }

        selectSwatch(selectedVariantId) {
            this.swatches.forEach(el => {
                if (el.dataset.variantId == selectedVariantId) {
                    el.classList.add('active');
                    this.currentVariantId = selectedVariantId;
                } else {
                    el.classList.remove('active');
                }
            });
        }
    }

    customElements.define('more-variants-drawer', MoreVariantsDrawer);
}

if (!customElements.get('theme-toggle')) {
    class ThemeToggle extends HTMLElement {
        constructor() {
            super();

            this.storageKey = 'theme-preference'
            this.theme = this.getColorPreference();
            const toggleEls = this.querySelectorAll('input');

            this.reflectPreference();

            toggleEls.forEach( (el) => {
                if (this.theme === 'dark') {
                    el.checked = true;
                }

                el.addEventListener('change', this.onThemeToggle.bind(this));
            });

            window.matchMedia('(prefers-color-scheme: dark)')
                .addEventListener('change', ({matches: isDark}) => {
                    this.theme = isDark ? 'dark' : 'light'
                    this.setPreference()
                });
        }

        connectedCallback() {
        }

        onThemeToggle(event)  {
            if (event.target.checked) {
                this.theme = 'dark';
            } else {
                this.theme = 'light';
            }

            this.setPreference();
        }

        getColorPreference() {
            if (safeStorage.get(this.storageKey)) {
                return safeStorage.get(this.storageKey)
            } else {
                return 'light';
                // return window.matchMedia('(prefers-color-scheme: dark)').matches
                //     ? 'dark'
                //     : 'light'
            }
        }

        setPreference() {
            safeStorage.set(this.storageKey, this.theme)
            this.reflectPreference()
        }

        reflectPreference() {
            document.firstElementChild.setAttribute('color-scheme', this.theme)
            document.body.classList.add(`theme-${this.theme}`);
        }
    }

    customElements.define('theme-toggle', ThemeToggle);
}

if (!customElements.get('line-clamped')) {
    class LineClamped extends HTMLElement {
        constructor() {
            super();

            this.textElement = this.querySelector('[data-line-clamped-text]');
            this.toggleButton = this.querySelector('[data-line-clamped-button]');

            this.textElement.classList.add('line-clamped');

            if (this.toggleButton) {
                this.toggleButton.addEventListener('click', () => {
                    if (this.textElement.classList.contains('line-clamped')) {
                        this.textElement.classList.remove('line-clamped');
                        this.toggleButton.textContent = this.toggleButton.dataset.lineClampedButtonLess;
                    } else {
                        this.textElement.classList.add('line-clamped');
                        this.toggleButton.textContent = this.toggleButton.dataset.lineClampedButtonMore;
                    }
                });
            } else {
                this.textElement.addEventListener('click', () => {
                    if (this.textElement.classList.contains('line-clamped')) {
                        this.textElement.classList.remove('line-clamped');
                    } else {
                        this.textElement.classList.add('line-clamped');
                    }
                });
            }
        }

        connectedCallback() {
            this.textElement.style['-webkit-line-clamp'] = this.textElement.dataset.lineClampedText;

            if (this.toggleButton) {
                if (this.textElement.scrollHeight > this.textElement.clientHeight) {
                    this.toggleButton.style.display = 'inline';
                }
            }
        }
    }

    customElements.define('line-clamped', LineClamped);
}

if (!customElements.get('cart-bubble')) {
    class CartBubble extends HTMLElement {
        cartUpdateUnsubscriber = undefined;
        cartClearUnsubscriber = undefined;

        constructor() {
            super();
        }

        connectedCallback() {
            this.cartUpdateUnsubscriber = window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, (event) => {
                this.updateCounter(event);
            });
            this.cartClearUnsubscriber = window.subscribe(window.PUB_SUB_EVENTS.cartClear, () => {
                this.clearCounter();
            });
        }

        disconnectedCallback() {
            if (this.cartUpdateUnsubscriber) {
                this.cartUpdateUnsubscriber();
            }
            if (this.cartClearUnsubscriber) {
                this.cartClearUnsubscriber();
            }
        }

        clearCounter() {
            document.querySelector('.header__nav__action__indicator')?.remove();
        }

        updateCounter(event) {
            if (!event.cartData?.sections?.['cart-bubble']) {
                return;
            }

            const elementToReplace = this.querySelector('.header__nav__action');
            elementToReplace.innerHTML = window.getSectionInnerHTML(
                event.cartData.sections['cart-bubble'],
                '.header__nav__action'
            );
        }
    }
    customElements.define('cart-bubble', CartBubble);
}

if (!customElements.get('copy-text')) {
    class CopyText extends HTMLElement {
        constructor() {
            super();

            this.text = this.textContent;
            this.button = this.querySelector('.copy-text-button');
        }

        connectedCallback() {
            this.button.addEventListener('click', (event) => {
                window.navigator.clipboard.writeText(this.text.trim())
                    .then(() => {
                        this.classList.add('success');

                        setTimeout(() => {
                            this.classList.remove('success');
                        }, 2000);
                    })
                    .catch(e => console.log(e));
            });
        }
    }
    customElements.define('copy-text', CopyText);
}

if (!customElements.get('add-to-project')) {
    /**
     *  @class
     *  @function  AddToProject
     *
     *  Adds items to a project in the customer portal (cabinet) instead of the cart.
     *
     *  Opens a dialog listing the customer's projects, then posts the chosen target to
     *  the portal. The portal is a subdomain of the storefront, so these requests are
     *  same-site: the portal session cookie is sent with `credentials: 'include'` and
     *  no third-party cookie is involved.
     *
     *  A customer who is not signed in is handed to the existing intent flow — a
     *  full-page POST that survives the sign-in round trip — rather than being asked
     *  to sign in inside a dialog that would then lose its state.
     */

    class AddToProject extends HTMLElement {
        onVariantChangeUnsubscriber = undefined;
        initialised = false;

        // Deliberately empty. A custom element constructor must not inspect or modify
        // its children: the element can be upgraded before its subtree has been
        // parsed, and the cart drawer re-renders this markup at runtime. Reading
        // children here threw "Cannot read properties of null".
        constructor() {
            super();
        }

        connectedCallback() {
            if (!this.initialise()) {
                return;
            }

            if (this.dataset.type !== 'product') {
                return;
            }

            // The theme already publishes variant changes; reuse that rather than
            // watching the DOM for the selected option.
            this.onVariantChangeUnsubscriber = window.subscribe(
                window.PUB_SUB_EVENTS.variantChange,
                this.handleVariantChange.bind(this)
            );
        }

        disconnectedCallback() {
            if (this.onVariantChangeUnsubscriber) {
                this.onVariantChangeUnsubscriber();
                this.onVariantChangeUnsubscriber = undefined;
            }
        }

        /**
         *  Wires up children once. Returns false when the expected markup is absent,
         *  so a single broken instance logs and stays inert instead of throwing and
         *  taking the rest of the page's scripts down with it.
         */
        initialise() {
            if (this.initialised) {
                return true;
            }

            this.button = this.querySelector('[data-open-dialog]');
            this.dialog = this.querySelector('dialog');
            const signIn = this.querySelector('[data-sign-in]');
            const createSubmit = this.querySelector('[data-create-submit]');
            const close = this.querySelector('[data-close]');
            this.confirm = this.querySelector('[data-confirm]');
            const createToggle = this.querySelector('[data-create-toggle]');

            if (!this.button || !this.dialog || !signIn || !createSubmit || !close || !this.confirm) {
                console.warn('add-to-project: expected markup missing, staying inert', this);
                return false;
            }

            this.portalUrl = (this.dataset.portalUrl || '').replace(/\/$/, '');
            if (this.portalUrl === '') {
                console.warn('add-to-project: no portal URL configured, staying inert', this);
                return false;
            }

            this.button.addEventListener('click', this.onOpenHandler.bind(this));
            signIn.addEventListener('click', this.signIn.bind(this));
            createSubmit.addEventListener('click', this.onCreateHandler.bind(this));
            close.addEventListener('click', () => this.dialog.close());
            this.confirm.addEventListener('click', this.onConfirmHandler.bind(this));

            // The room step (2026-10-28). Optional markup: a cached older snippet
            // without it adds straight to the project, as before.
            this.roomConfirm = this.querySelector('[data-room-confirm]');
            if (this.roomConfirm) {
                this.roomConfirm.addEventListener('click', this.onRoomConfirmHandler.bind(this));
                this.querySelector('[data-room-back]')?.addEventListener('click', () => this.showState('choose'));

                const roomToggle = this.querySelector('[data-room-create-toggle]');
                const roomInput = this.querySelector('[data-new-room]');
                roomToggle?.addEventListener('click', () => this.selectNewRoom());
                roomInput?.addEventListener('input', () => this.updateRoomConfirm());
                roomInput?.addEventListener('keydown', (event) => {
                    if (event.key === 'Enter') {
                        event.preventDefault();
                        this.onRoomConfirmHandler();
                    }
                });
            }

            // The name field starts hidden: creating is the rarer of the two acts,
            // and an open input competed with the list for the customer's attention.
            if (createToggle) {
                createToggle.addEventListener('click', () => {
                    const form = this.dialog.querySelector('[data-create-form]');
                    if (!form) return;
                    form.hidden = !form.hidden;
                    if (!form.hidden) form.querySelector('[data-new-name]')?.focus();
                });
            }

            this.initialised = true;
            return true;
        }

        handleVariantChange({ variant, productId }) {
            if (!this.button) {
                return;
            }

            if (this.dataset.productId && productId && this.dataset.productId != productId) {
                return;
            }

            if (!variant) {
                this.button.disabled = true;
                return;
            }

            this.dataset.variantId = variant.id;
            this.dataset.sku = variant.sku;
            this.dataset.variantTitle = variant.title;
            this.dataset.price = String(Number(variant.price || 0) / 100);
            // Deliberately not disabled on variant.available: a project is a wishlist
            // or a quote, so an out-of-stock or made-to-order item still belongs in one.
            this.button.disabled = false;
        }

        /* ------------------------------------------------------------------ dialog */

        showState(name) {
            this.dialog.querySelectorAll('[data-state]').forEach(function(el) {
                el.hidden = el.dataset.state !== name;
            });
        }

        async onOpenHandler() {
            if (this.button.disabled) {
                return;
            }

            this.showState('loading');
            if (!this.dialog.open) this.dialog.showModal();

            try {
                // For one product, the portal also says how much of it each room
                // already holds, so the room step can say "2 already there".
                const query = this.dataset.type !== 'cart' && this.dataset.variantId
                    ? `?variantId=${encodeURIComponent(this.dataset.variantId)}`
                    : '';
                const response = await fetch(`${this.portalUrl}/api/projects${query}`, {
                    credentials: 'include',
                    headers: { Accept: 'application/json' },
                });

                if (!response.ok) {
                    throw new Error(`/api/projects returned ${response.status}`);
                }

                const data = await response.json();

                if (!data.authenticated) {
                    this.showState('signed-out');
                    return;
                }

                if (data.locked && data.projects.length === 0 && !data.canCreate) {
                    this.showLocked(data.locked);
                    return;
                }

                this.renderProjects(data);
            } catch (error) {
                console.error('Add to project: could not load projects', error);
                this.showState('error');
            }
        }

        renderProjects(data) {
            const list = this.dialog.querySelector('[data-projects]');
            list.textContent = '';

            // Cleared on every open: a selection left over from last time would arm
            // the confirm button for a project the customer has not looked at.
            this.selected = null;
            this.updateConfirm();

            data.projects.forEach((project) => {
                const item = document.createElement('li');
                const row = document.createElement('button');
                row.type = 'button';
                row.className = 'add-to-project__row';
                // `radio` with `aria-checked`, because the whole row is the control
                // and a real <input> inside a <button> is not valid markup.
                row.setAttribute('role', 'radio');
                row.setAttribute('aria-checked', 'false');

                if (project.imageUrl) {
                    const thumb = document.createElement('img');
                    thumb.className = 'add-to-project__row__thumb';
                    thumb.src = project.imageUrl;
                    // Decorative: the project's name is right beside it.
                    thumb.alt = '';
                    thumb.loading = 'lazy';
                    row.appendChild(thumb);
                } else {
                    const empty = document.createElement('span');
                    empty.className = 'add-to-project__row__thumb add-to-project__row__thumb--empty';
                    row.appendChild(empty);
                }

                const text = document.createElement('span');
                text.className = 'add-to-project__row__text';

                const name = document.createElement('b');
                // textContent, not innerHTML: project names are customer input.
                name.textContent = project.name;

                const meta = document.createElement('small');
                meta.textContent = this.describeProject(project, list);

                text.append(name, meta);

                const mark = document.createElement('span');
                mark.className = 'add-to-project__row__mark';

                row.append(text, mark);
                row.addEventListener('click', () => this.select(project, row));

                item.appendChild(row);
                list.appendChild(item);
            });

            // Retail customers are limited to one project, so the portal tells us
            // whether creating another is even possible.
            this.dialog.querySelector('[data-create]').hidden = !data.canCreate;

            // No projects yet: nothing to choose, so only the create form, already open.
            const isEmpty = data.projects.length === 0;
            const footer = this.dialog.querySelector('.add-to-project__footer');
            list.hidden = isEmpty;
            this.confirm.hidden = isEmpty;
            if (footer) footer.classList.toggle('add-to-project__footer--empty', isEmpty);
            const form = this.dialog.querySelector('[data-create-form]');
            if (form) form.hidden = !isEmpty;
            const toggle = this.dialog.querySelector('[data-create-toggle]');
            if (toggle) toggle.hidden = isEmpty;

            this.showState('choose');
        }

        /**
         *  Marks a row. **Nothing is sent from here** — that is the whole of this
         *  change: choosing used to post immediately, against a list where three
         *  projects are called "My project", so a mis-tap was silent and final.
         */
        select(project, row) {
            this.dialog.querySelectorAll('.add-to-project__row').forEach((other) => {
                other.setAttribute('aria-checked', 'false');
            });
            row.setAttribute('aria-checked', 'true');
            this.selected = project;
            this.updateConfirm();
        }

        /** The button names its destination, so the act is readable before it happens. */
        updateConfirm() {
            if (!this.confirm) {
                return;
            }

            if (!this.selected) {
                this.confirm.disabled = true;
                this.confirm.textContent = this.confirm.dataset.labelEmpty || '';
                return;
            }

            this.confirm.disabled = false;
            this.confirm.textContent = (this.confirm.dataset.labelAdd || '[name]')
                .replace('[name]', this.selected.name);
        }

        onConfirmHandler() {
            if (!this.selected) {
                return;
            }
            // A project organised by room asks which room first; one that is not
            // (no rooms listed) is added to as it always was.
            if (this.roomConfirm && Array.isArray(this.selected.rooms) && this.selected.rooms.length > 0) {
                this.renderRooms(this.selected);
                return;
            }
            this.submit({ projectId: this.selected.id });
        }

        /* ------------------------------------------------------------------- rooms */

        /**
         *  The rooms of the chosen project, as rows like the projects'. Each says
         *  what adding there does — a new line, or more on the line already there —
         *  when the portal sent counts, which it does for a single product.
         */
        renderRooms(project) {
            const list = this.dialog.querySelector('[data-rooms]');
            const prompt = this.dialog.querySelector('[data-room-prompt]');
            list.textContent = '';
            if (prompt) {
                prompt.textContent = (prompt.dataset.template || '[name]').replace('[name]', project.name);
            }

            this.selectedRoom = null;
            const form = this.dialog.querySelector('[data-room-create-form]');
            const input = this.dialog.querySelector('[data-new-room]');
            if (form) form.hidden = true;
            if (input) input.value = '';

            project.rooms.forEach((room) => {
                const item = document.createElement('li');
                const row = document.createElement('button');
                row.type = 'button';
                row.className = 'add-to-project__row';
                row.setAttribute('role', 'radio');
                row.setAttribute('aria-checked', 'false');

                const text = document.createElement('span');
                text.className = 'add-to-project__row__text';

                const name = document.createElement('b');
                // textContent: room names are customer input. The root has no name
                // of its own and is called what the cabinet calls it.
                const label = room.label || list.dataset.labelUngrouped || '';
                name.textContent = label;
                text.appendChild(name);

                if (typeof room.qty === 'number') {
                    const meta = document.createElement('small');
                    meta.textContent = room.qty > 0
                        ? (list.dataset.labelThere || '[count]').replace('[count]', String(room.qty))
                        : list.dataset.labelNew || '';
                    text.appendChild(meta);
                }

                const mark = document.createElement('span');
                mark.className = 'add-to-project__row__mark';

                row.append(text, mark);
                row.addEventListener('click', () => {
                    this.markRoom(row);
                    this.selectedRoom = { groupId: room.id, label };
                    if (form) form.hidden = true;
                    this.updateRoomConfirm();
                });

                item.appendChild(row);
                list.appendChild(item);
            });

            this.updateRoomConfirm();
            this.showState('room');
        }

        markRoom(row) {
            this.dialog.querySelectorAll('[data-rooms] .add-to-project__row').forEach((other) => {
                other.setAttribute('aria-checked', 'false');
            });
            if (row) row.setAttribute('aria-checked', 'true');
        }

        /** "+ New room": the name field is the choice, so the rows are cleared. */
        selectNewRoom() {
            const form = this.dialog.querySelector('[data-room-create-form]');
            if (!form) return;
            this.markRoom(null);
            this.selectedRoom = 'new';
            form.hidden = false;
            form.querySelector('[data-new-room]')?.focus();
            this.updateRoomConfirm();
        }

        newRoomName() {
            return (this.dialog.querySelector('[data-new-room]')?.value || '').trim();
        }

        /** Names the room it will add to, like the project step's button. */
        updateRoomConfirm() {
            const button = this.roomConfirm;
            if (!button) return;

            const label = this.selectedRoom === 'new'
                ? this.newRoomName()
                : this.selectedRoom ? this.selectedRoom.label : '';

            button.disabled = label === '';
            button.textContent = label === ''
                ? button.dataset.labelEmpty || ''
                : (button.dataset.labelAdd || '[name]').replace('[name]', label);
        }

        onRoomConfirmHandler() {
            if (!this.selected || !this.selectedRoom) {
                return;
            }
            if (this.selectedRoom === 'new') {
                const name = this.newRoomName();
                if (name === '') return;
                this.submit({ projectId: this.selected.id, newRoomName: name });
                return;
            }
            this.submit({ projectId: this.selected.id, groupId: this.selectedRoom.groupId });
        }

        /** "3 items \u00b7 yesterday", or the empty phrase when there is nothing in it. */
        describeProject(project, list) {
            const count = Number(project.itemCount) || 0;

            if (count === 0) {
                return list.dataset.labelEmpty || '';
            }

            const template = count === 1 ? list.dataset.labelItemsOne : list.dataset.labelItems;
            const items = (template || '[count]').replace('[count]', String(count));
            const when = this.describeWhen(project.updatedAt);
            return when ? items + ' \u00b7 ' + when : items;
        }

        /**
         *  When the project was last touched, in the page's own language.
         *
         *  `Intl.RelativeTimeFormat` rather than a translated string per case:
         *  "yesterday", "3 days ago" and "last week" would otherwise be three more
         *  keys in three locale files, and still wrong for the fourth case.
         */
        describeWhen(iso) {
            if (!iso) {
                return '';
            }

            const then = new Date(iso);
            if (Number.isNaN(then.getTime())) {
                return '';
            }

            const lang = document.documentElement.lang || 'en';
            // Negative only: an `updatedAt` in the future is clock skew, not a
            // project edited tomorrow.
            const days = Math.min(Math.round((then.getTime() - Date.now()) / 86400000), 0);

            try {
                return new Intl.RelativeTimeFormat(lang, { numeric: 'auto' }).format(days, 'day');
            } catch (error) {
                // A locale Intl does not know is not a reason to lose the row.
                return then.toLocaleDateString(lang);
            }
        }

        onCreateHandler() {
            const input = this.dialog.querySelector('[data-new-name]');
            const name = input.value.trim();
            if (name === '') {
                input.focus();
                return;
            }
            this.submit({ newProjectName: name });
        }

        /* ------------------------------------------------------------------ submit */

        async submit(target) {
            const lines = await this.getLines();
            if (lines.length === 0) {
                this.showState('error');
                return;
            }

            this.showState('loading');

            try {
                const response = await fetch(`${this.portalUrl}/api/projects/add`, {
                    method: 'POST',
                    credentials: 'include',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ ...target, lines }),
                });

                if (response.status === 401) {
                    // The session expired between opening the dialog and submitting.
                    this.showState('signed-out');
                    return;
                }

                if (response.status === 409) {
                    const refusal = await response.json().catch(() => null);
                    if (refusal && refusal.error === 'project-locked') {
                        this.showLocked({ id: refusal.projectId, name: refusal.name, status: refusal.status });
                        return;
                    }
                }

                if (!response.ok) {
                    throw new Error(`/api/projects/add returned ${response.status}`);
                }

                const result = await response.json();
                this.showDone(result);

                // A manager building a project for a customer is not a customer
                // adding to their own, and must not be counted as one.
                if (result.staff) {
                    return;
                }

                const eventLines = await this.getEventLines();
                const eventItems = eventLines.map((line) => ({
                    item_id: line.sku,
                    item_name: line.name,
                    item_brand: line.brand,
                    item_variant: line.variant,
                    price: line.price,
                    quantity: line.quantity,
                }));

                let eventCurrency = 'EUR';
                let eventValue = 0;
                eventItems.forEach((item) => {
                    eventCurrency = item.currency;
                    eventValue += item.quantity * item.price;
                });

                document.dispatchEvent(new CustomEvent('add_to_project', {
                    detail: {
                        cab_project_id: result.projectId,
                        new_project: !!target.newProjectName,
                        qty_increased: result.incremented > 0,
                        ecommerce_currency: eventCurrency,
                        ecommerce_value: eventValue,
                        ecommerce_items: eventItems,
                    },
                    bubbles: true,
                    cancelable: true
                }));
            } catch (error) {
                console.error('Add to project failed', error);
                this.showState('error');
            }
        }

        showDone(result) {
            const panel = this.dialog.querySelector('[data-state="done"]');
            const message = panel.querySelector('[data-done-message]');
            const added = Number(result.added) || 0;
            const incremented = Number(result.incremented) || 0;
            const missing = (result.missing || []).length;

            // Templates come from data attributes so the copy stays in the locale
            // files, following how the theme hands other strings to JS.
            const parts = [];
            if (added > 0) {
                parts.push((added === 1 ? panel.dataset.messageAddedOne : panel.dataset.messageAdded).replace('[count]', added));
            }
            if (incremented > 0) {
                // One variant that was already there — which is every add from a
                // product page — is told what it now holds rather than that "1
                // item(s) had their quantity increased", a sentence that leaves the
                // customer to open the project to find out what happened. The
                // resulting quantity comes from the portal: it is the only side that
                // knows what was in the project before this.
                const only = incremented === 1 && added === 0 ? (result.incrementedTo || [])[0] : null;
                parts.push(
                    only && Number(only.qty) > 0
                        ? panel.dataset.messageIncreasedTo.replace('[qty]', Number(only.qty))
                        : (incremented === 1 ? panel.dataset.messageIncreasedOne : panel.dataset.messageIncreased).replace('[count]', incremented)
                );
            }
            if (missing > 0) {
                // Said out loud rather than hidden: a silently shorter project is worse.
                parts.push((missing === 1 ? panel.dataset.messageUnavailableOne : panel.dataset.messageUnavailable).replace('[count]', missing));
            }

            message.textContent = parts.join(' ');
            // The project the items actually went to, not the account index: the
            // customer pressed a button naming a project, and the next screen should
            // be that project. Falls back to the account when the portal did not say
            // which — it always does today, and a dead link would be worse than a
            // broader one.
            //
            // Staff (a manager signed in with their own address) build projects that
            // wait for a customer and are not in any cabinet, so the portal names
            // where theirs opens instead: the staff section.
            this.dialog.querySelector('[data-portal-link]').href = result.staff
                ? result.projectUrl || `${this.portalUrl}/account`
                : result.projectId
                    ? `${this.portalUrl}/projects/${encodeURIComponent(result.projectId)}`
                    : `${this.portalUrl}/account`;
            this.showState('done');
        }

        /**
         *  The customer's only project can no longer be changed: an invoice was
         *  requested for it, or it is ordered. Said plainly, with a way to it,
         *  rather than offering a "create" the portal would refuse.
         */
        showLocked(locked) {
            const panel = this.dialog.querySelector('[data-state="locked"]');
            if (!panel) {
                this.showState('error');
                return;
            }

            const template = locked.status === 'INVOICE_REQUESTED'
                ? panel.dataset.messageInvoice
                : panel.dataset.messageClosed;
            // textContent: the project name is customer input.
            panel.querySelector('[data-locked-message]').textContent =
                (template || '').replace('[name]', locked.name || '').replace(/\s+/g, ' ').trim();
            panel.querySelector('[data-locked-link]').href = locked.id
                ? `${this.portalUrl}/projects/${encodeURIComponent(locked.id)}`
                : `${this.portalUrl}/account`;
            this.showState('locked');
        }

        async getLines() {
            if (this.dataset.type === 'cart') {
                return this.getCartLines();
            }

            const variantId = this.dataset.variantId;
            if (!variantId) {
                return [];
            }

            const quantityInput = this.closest('.product-form, .product__info, form')?.querySelector(
                '[name="quantity"]'
            );

            return [{ variantId: String(variantId), quantity: Number(quantityInput?.value) || 1 }];
        }


        async getEventLines() {
            if (this.dataset.type === 'cart') {
                return this.getEventCartLines()
            }

            const sku = this.dataset.sku;
            const name = this.dataset.name;
            const variantTitle = this.dataset.variantTitle;
            const brand = this.dataset.brand;
            const price = Number(this.dataset.price) ?? 0;
            const currency = this.dataset.currency;

            const quantityInput = this.closest('.product-form, .product__info, form')?.querySelector(
                '[name="quantity"]'
            );

            return [{
                sku: String(sku),
                name: String(name),
                variant: String(variantTitle),
                brand: String(brand),
                price: price,
                quantity: Number(quantityInput?.value) || 1,
                currency: String(currency) || 'EUR',
            }];
        }

        async getCartLines() {
            // Shopify's own cart JSON, so the drawer's rendered markup is never parsed.
            const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
                headers: { Accept: 'application/json' },
            });

            if (!response.ok) {
                throw new Error(`cart.js returned ${response.status}`);
            }

            const cart = await response.json();

            return (cart.items || []).map((item) => ({
                variantId: String(item.variant_id),
                quantity: item.quantity,
            }));
        }

        async getEventCartLines() {
            const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
                headers: { Accept: 'application/json' },
            });

            if (!response.ok) {
                throw new Error(`cart.js returned ${response.status}`);
            }

            const cart = await response.json();

            return (cart.items || []).map((item) => ({
                sku: String(item.sku),
                name: String(item.title),
                variant: String(item.variant_title),
                brand: String(item.vendor),
                price: item.presentment_price,
                quantity: item.quantity,
                currency: cart.currency,
            }));
        }

        /* ----------------------------------------------------------------- sign in */

        async signIn() {
            const lines = await this.getLines();

            // Hand off to the portal's intent flow: a full-page POST that stores the
            // items, sends the customer through sign-in, and adds them afterwards.
            // Doing it this way means the selection is not lost on the round trip.
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = `${this.portalUrl}/api/intents/cart`;
            form.hidden = true;

            lines.forEach((line) => {
                form.appendChild(this.hiddenInput('variant_id', line.variantId));
                form.appendChild(this.hiddenInput('quantity', line.quantity));
            });

            document.body.appendChild(form);
            form.submit();
        }

        hiddenInput(name, value) {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = name;
            input.value = value;
            return input;
        }
    }

    customElements.define('add-to-project', AddToProject);
}


document.querySelectorAll('.copy-button').forEach(button => {
    button.addEventListener('click', async () => {
        const text = button.getAttribute('data-copy');
        const iconCopy = button.querySelector('.icon-copy');
        const iconCheck = button.querySelector('.icon-check');

        try {
            // Копіювання в буфер
            await navigator.clipboard.writeText(text);

            // Візуальний фідбек
            button.classList.add('success');
            iconCopy.style.display = 'none';
            iconCheck.style.display = 'block';

            // Повертаємо все назад через 2 секунди
            setTimeout(() => {
                button.classList.remove('success');
                iconCopy.style.display = 'block';
                iconCheck.style.display = 'none';
            }, 2000);

        } catch (err) {
            console.error('Не вдалося скопіювати:', err);
        }
    });
});

document.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('click', async (event)  => {
        if (navigator.share) {
            const shareBtn = event.target.closest('[data-button-share]');
            if (shareBtn) {
                try {
                    await navigator.share({
                        title: document.title,
                        url: shareBtn.dataset.buttonShare ?? document.location.href,
                    });
                } catch (err) {
                    console.error('Error sharing:', err);
                }
            }
        }
    });
});

window.addEventListener('pageshow', () => {
    document.querySelectorAll('[type="radio"]').forEach((e, i) => {
        let initialChecked;
        if (e.getAttribute('checked') != null) {
            initialChecked = e;
        }

        e.checked = false;
        if (initialChecked) {
            initialChecked.checked = true;
        }
    });
});

/* Account icon: where it leads depends on the portal session (snippets/account-link.liquid). */
{
    const links = document.querySelectorAll('[data-account-link]');
    const portalUrl = links[0]?.dataset.portalUrl;

    if (portalUrl) {
        fetch(`${portalUrl}/api/session`, { credentials: 'include' })
            .then((response) => (response.ok ? response.json() : null))
            .then((session) => {
                // No answer leaves the links as rendered rather than guessing.
                if (!session) return;
                links.forEach((link) => {
                    link.href = session.authenticated ? session.accountUrl : link.dataset.loginUrl;
                    link.classList.toggle('authorized', session.authenticated);
                });
            })
            .catch(() => {});
    }
}
